"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./base");
var size_1 = require("./controller/size");
var k_line_1 = require("./shape/k-line");
var KLine = /** @class */ (function (_super) {
    tslib_1.__extends(KLine, _super);
    function KLine(cfg) {
        var _this = _super.call(this, tslib_1.__assign({ type: 'kline', shapeType: 'kline', generatePoints: true }, cfg)) || this;
        var sizeController = new size_1.default(_this);
        _this.set('sizeController', sizeController);
        _this.set('shapeFactory', k_line_1.default);
        return _this;
    }
    KLine.prototype.createShapePointsCfg = function (obj) {
        var cfg = _super.prototype.createShapePointsCfg.call(this, obj);
        cfg.size = this.getNormalizedSize(obj);
        return cfg;
    };
    return KLine;
}(base_1.default));
exports.default = KLine;
//# sourceMappingURL=k-line.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/k-line.js
// module id = 810
// module chunks = 37